var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"enem-year-selection-form"},[_c('SearchCard',{staticClass:"enem-year-selection-form__search",attrs:{"search-disabled":"","list-items":_vm.items,"selected":_vm.selected},on:{"selected":_vm.selectedHandler}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }